module.exports = __webpack_public_path__ + "img/note.2520ce65.svg";